var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilitator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.64 0 0 0.64 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.1 0 -0 -0.1 0 50)",
    d: "M337 462C 304 426 329 370 377 370C 402 370 430 400 430 427C 430 473 368 496 337 462zM404 438C 412 424 411 417 398 404C 368 374 323 413 350 446C 366 464 389 461 404 438z",
    stroke: "#9CA3AF",
    strokeWidth: 10,
    fill: "#9CA3AF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 0.1 0.1 0 -31 -0)",
    d: "M30 405L30 340L160 340L160 470L30 470L30 405zM140 405L140 360L50 360L50 450L140 450L140 405z",
    stroke: "#9CA3AF",
    strokeWidth: 10,
    fill: "#9CA3AF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.1 0 -0 -0.1 0 50)",
    d: "M308 350C 299 344 276 318 257 291C 224 246 218 242 193 249C 171 255 164 263 162 288L162 288L159 320L30 320L30 190L95 190C 142 190 160 194 160 203C 160 213 146 216 105 212L105 212L50 208L50 300L95 300C 129 300 140 296 140 284C 140 272 133 270 110 275C 54 287 79 261 140 244C 172 235 207 219 216 209C 240 183 251 185 282 222L282 222L309 255L310 149C 310 31 314 23 370 23C 421 23 430 35 430 100C 430 149 433 158 450 163C 468 168 470 177 470 248C 470 346 459 360 379 360C 349 360 318 355 308 350zM438 328C 453 313 454 180 440 180C 435 180 430 205 430 235C 430 265 426 290 420 290C 414 290 410 242 410 165C 410 61 408 40 395 40C 383 40 380 54 380 110C 380 150 376 180 370 180C 364 180 360 150 360 110C 360 54 357 40 345 40C 332 40 330 61 330 170C 330 242 326 300 322 300C 317 300 299 280 281 255C 263 230 245 210 239 210C 225 210 228 218 257 258C 314 336 320 340 375 340C 403 340 431 335 438 328z",
    stroke: "#9CA3AF",
    strokeWidth: 10,
    fill: "#9CA3AF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.1 0 -0 -0.1 0 50)",
    d: "M30 105L30 40L160 40L160 170L30 170L30 105zM140 105L140 60L50 60L50 150L140 150L140 105z",
    stroke: "#9CA3AF",
    strokeWidth: 10,
    fill: "#9CA3AF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilitator);
export default __webpack_public_path__ + "static/media/facilitator.bc8260b55efe0f996621dd6627d01b52.svg";
export { ForwardRef as ReactComponent };